import type { ShareConfig } from '../../shared/types';

import { useIsMobileNativeShareCapable } from './shared/useIsMobileNativeShareCapable';

export function useTiktokAvailable(config: ShareConfig): boolean {
	return useIsMobileNativeShareCapable() && !!config.tiktok?.enabled;
}
